<!--
 * @Description: 金融
 * @Author: yangsibo
 * @Date: 2022-11-09 14:41:59
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-11-09 14:42:17
 * @FilePath: /adm.xiangli360.com/src/views/Bank/index.vue
-->

<template>
    <router-view />
</template>

<script>
export default {
	name: 'Bank',
};
</script>
